import { HttpClient, HttpHeaders, httpResource } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { REQUIRE_AUTH_HEADER } from '@psu-pennstateit-swe/utils/security';
import { map, Observable } from 'rxjs';
import { SSRM_CONFIG } from '../../app-properties.model';
import { CareUnit, careUnitSchema, ServerCareUnit } from '../relationships/relationships.model';

const headers = new HttpHeaders({ [REQUIRE_AUTH_HEADER]: 'true' });

@Injectable({
  providedIn: 'root',
})
export class CareUnitsData {
  private readonly http = inject(HttpClient);
  private readonly ssrmConfig = inject(SSRM_CONFIG);
  private readonly baseUrl = `${this.ssrmConfig.url.replace(/\/+$/, '')}/careUnits`;

  readonly careUnitsResource = httpResource<CareUnit[]>(
    () => ({
      url: this.baseUrl,
      method: 'GET',
      headers,
    }),
    {
      parse: (response) => careUnitSchema.array().parse(response),
    },
  );

  addCareUnit(name: string): Observable<CareUnit> {
    return this.http
      .post<ServerCareUnit>(this.baseUrl, { name }, { headers })
      .pipe(map((careUnit) => careUnitSchema.parse(careUnit)));
  }
}
